<script>
import {
  VAutocomplete, VCard, VContainer, VForm, VSelect, VTextField,
} from 'vuetify/lib/components'
import {
  VBtn, VCol, VDataTable, VRow, VSpacer,
} from 'vuetify'
import { mdiCheckCircle } from '@mdi/js'

export default {
  name: 'ConfirmBooking',
  components: {
    VCard,
    VContainer,
    VForm,
    VSelect,
    VTextField,
    VAutocomplete,
    VBtn,
    VCol,
    VDataTable,
    VRow,
    VSpacer,
  },
  setup() {
    return {
      icon: mdiCheckCircle,
    }
  },
  data() {
    return {
      bookingId: this.$route.params.id,
      booking: null,
      payment_type_list: [],
      stay_payment: {
        pay_stay_date: '',
        pay_stay_ref: '',
        pay_stay_amount: 0,
        stay_id: this.$route.params.id,
        payment_type_id: 0,
      },
      amount_to_pay: 0,
    }
  },
  computed: {
    bookingData() {
      return this.booking
    },
  },
  mounted() {
    this.$axios.get(this.$endpoint.FindBooking(this.bookingId)).then(respBooking => {
      this.booking = respBooking.data.data
      this.amount_to_pay = this.booking.stays_remaining_amount
    }).catch(err => {
      console.error(err)
    })
    this.loadPaymentType()
  },
  methods: {
    loadPaymentType() {
      this.$axios.get(this.$endpoint.LoadCustomerPaymentType).then(rp => {
        this.payment_type_list = rp.data
      })
    },
    validBookingConfirmation() {
      if (this.stay_payment.pay_stay_date.length < 5 || this.stay_payment.pay_stay_amount <= 0 || this.stay_payment.payment_type_id == 0) {
        this.$swal.fire(
          {
            icon: 'error',
            title: 'Ooops',
            text: 'Veulliez correctement renseigné tous les champs',
            confirmButtonText: 'Compris',
            confirmButtonColor: '#D62F2F',
          },
        )
      } else {
        const stayConfirmData = {
          stayInfos: {
            stays_remaining_amount: this.booking.stays_total_price_to_pay - this.stay_payment.pay_stay_amount,
            stays_status: this.booking.is_booking ? 300 : 400,
            stays_pay_off: (this.booking.stays_total_price_to_pay - this.stay_payment.pay_stay_amount) <= 0,
          },
          paymentInfos: this.stay_payment,
        }
        this.$axios.put(this.$endpoint.ValidBookingConfirmation, stayConfirmData).then(() => {
          this.$router.push('/administration')
        })
      }
    },
    cancelBookingConfirmation() {
      this.$swal.fire({
        title: 'Souhaitez-vous vraiment annuler cette reservation ?',
        text: 'Veuillez notez que cette action est irreversible!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Annuler!',
        cancelButtonText: 'Non, Retour!',
        reverseButtons: true,
      }).then(result => {
        if (result.isConfirmed) {
          console.log(this.booking.id);
          this.$axios.delete(this.$endpoint.CancelBooking(this.booking.id)).then(response => {
            this.$swal.fire({
              title: 'Annulation!',
              text: response?.data?.message ?? 'La reservation bien été annulé.',
              icon: 'success',
            })
            this.$router.push('/administration')
          })
        } else if (
        /* Read more about handling dismissals below */
          result.dismiss === this.$swal.DismissReason.cancel
        ) {
          console.log('cancel')
        }
      })
    },
  },
}
</script>

<template>
  <div class="auth-wrapper auth-v1">
    <div
      class="auth-inner"
      style="width:60% !important;"
    >
      <v-card>
        <v-card-title class="align-start">
          <span class="font-weight-semibold">Confirmation de réservation</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-subtitle class="mb-8 mt-n5">
          <span class="font-weight-semibold text--primary me-1">Détailles du séjour</span>
          <!--      <span>😎 this month</span>-->
        </v-card-subtitle>
        <v-card-text>
          <v-row v-if="bookingData">
            <v-col>
              Appartement concerné: <span class="font-weight-semibold">{{ bookingData.room.room_name }}</span>
            </v-col>
            <v-col>
              type d'appartement: <span class="font-weight-semibold">{{
                bookingData.room.room_type.room_type_name
              }}</span>
            </v-col>
            <v-col>
              Coût de la nuitée:<span class="font-weight-semibold"> {{ bookingData.room.room_total_price }}</span>
            </v-col>
          </v-row>
          <v-row v-if="bookingData">
            <v-col>
              Date entrée <span class="font-weight-semibold">{{
                new Date(bookingData.stays_enter_date).toLocaleString()
              }}</span>
            </v-col>
            <v-col>
              Date depart <span
                class="font-weight-semibold"
              >{{ new Date(bookingData.stays_leaving_date).toLocaleString() }}</span>
            </v-col>
            <v-col>
              Coût total du séjour <span class="font-weight-semibold">{{ bookingData.stays_total_price_to_pay }}</span>
            </v-col>
          </v-row>
          <v-row v-if="bookingData">
            <v-col>
              Nombre de nuitée: <span class="font-weight-semibold">{{ bookingData.stays_number_of_days }}</span>
            </v-col>
            <v-col>
              Nom complet du client: <span class="font-weight-semibold">{{
                bookingData.customer.cust_sexe
              }} {{ bookingData.customer.cust_lastname }} {{ bookingData.customer.cust_firstname }}</span>
            </v-col>
            <v-col>
              Contact du client: <span class="font-weight-semibold">{{ bookingData.customer.cust_contact }}</span>
            </v-col>
          </v-row>
          <v-container v-if="!bookingData">
            <h1 class="font-weight-bold">
              Aucune Référence trouvé pour ce séjour !
            </h1>
          </v-container>
          <v-container v-if="bookingData && bookingData.stays_status == 250">
            <v-row style="margin-top: 1%;">
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="amount_to_pay"
                  dense
                  :disabled="true"
                  type="numeric"
                  hide-details
                  required
                  label="Montant restant à payer"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="stay_payment.payment_type_id"
                  dense
                  :items="payment_type_list"
                  :item-value="'id'"
                  :item-text="item=>item.pay_typ_name"
                  label="Mode paiement"
                  outlined
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="stay_payment.pay_stay_date"
                  dense
                  type="date"
                  required
                  hide-details
                  label="Date de paiement"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="stay_payment.pay_stay_ref"
                  dense
                  hide-details
                  label="Reference de paiement"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="stay_payment.pay_stay_amount"
                  dense
                  type="numeric"
                  hide-details
                  label="Montant du paiement"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-btn
                  color="primary"
                  @click="validBookingConfirmation()"
                >
                  Confirmer la réservation
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-btn
                  color="primary"
                  @click="cancelBookingConfirmation()"
                >
                  Annuler la réservation
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="bookingData && bookingData.stays_status != 250">
            <v-icon
              color="success"
              :size="85"
              center
            >
              {{ icon }}
            </v-icon>
            <h1>Ce séjour à déjà été confirmé </h1>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
